// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__l6nSH","savePackageButton":"ClientWallet_savePackageButton__14T_u"};